import { NzToUi, UiToNz } from "./core.models";

export function uiToNz<T extends object>(input: T): UiToNz<T>;
export function uiToNz(input: string): string;
export function uiToNz(input: unknown): unknown {
  if (typeof input === "string" && input.startsWith("ui")) {
    return `nz${input.substring(2)}`;
  }

  if (typeof input === "object" && input != null) {
    const entries = Object.entries(input);
    if (!entries.some(([key]) => key.startsWith("ui"))) {
      return input;
    }

    const copy = {};
    for (const [key, value] of entries) {
      copy[uiToNz(key)] = value;
    }
    return copy;
  }

  return input;
}

export function nzToUi<T extends object>(input: T): NzToUi<T>;
export function nzToUi(input: string): string;
export function nzToUi(input: unknown): unknown {
  if (typeof input === "string" && input.startsWith("nz")) {
    return `ui${input.substring(2)}`;
  }

  if (typeof input === "object" && input != null) {
    const entries = Object.entries(input);
    if (!entries.some(([key]) => key.startsWith("nz"))) {
      return input;
    }

    const copy = {};
    for (const [key, value] of entries) {
      copy[nzToUi(key)] = value;
    }
    return copy;
  }

  return input;
}
